module.exports = __webpack_public_path__ + "static/hcpaincream-d29acb1f507e0fdc9440d2f2cdf6baeb.jpg";